<script lang="ts">
    
    import type { Board } from "../../Model/Board";
    import AspectRatio from "../Shared/AspectRatio.svelte";
    import Cell from "./Cell.svelte";

    export let board: Board;

</script>

<div class="board-bingo-90 notranslate">
    <AspectRatio ratio={1/3}>
        <div class="cells">
            {#each board.cells as cell}
                <Cell {cell} />
            {/each}
        </div>
    </AspectRatio>
</div>

<style lang="scss">

    $separation: 0.8vw;

    .board-bingo-90 {
        padding: $separation;
    }

    .cells {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(9, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: $separation;
    }

</style>
